import axios from 'axios';
import auth from './auth';

export default {
  state: {
    lang: {},
    user: null,
    brandData: {}
  },
  mutations: {
    login(state, user) {
      state.user = user;
    },
    logout(state) {
      state.user = null;
    },
    setLang(state, lang) {
      state.lang = { ...state.lang, ...lang };
    },
    updateUserMetadata(state, metadata) {
      auth.updateMeta(metadata);
      state.user = auth.authenticatedUser();
    },
    setQuickLinks(state, links) {
      auth.updateMetadata(links);
      state.user = auth.authenticatedUser();
    },
    setBrandData(state, json) {
      state.brandData = json;
    }
  },
  actions: {
    async initCore({ commit }) {
      // temporary test api.
      // const branding = await axios.get('https://assets.grooveapps.com/css/metadatas.json');
      
      // will be replaced by groove api
      const branding = {
        "brandName": "Groove.CM",
        "brandAltName": "GrooveFunnels",
        "brandUrl": "https://groove.cm",
        "brandLogo": "https://assets.grooveapps.com/css/groovecm.svg",
        "brandEmail": "info@groovedigital.com",
        "brandSupportEmail": "support@groovedigital.com",
        "favicon": "data:image/png;base64,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",
        "appCategories": [
            {
                "title": "Apps",
                "description": "All Groove Apps",
                "icon": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": "apps"
            },
            {
                "title": "Services",
                "description": "Services",
                "icon": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": "services"
            },
            {
                "title": "Training",
                "description": "Training",
                "icon": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": "training"
            },
            {
                "title": "Social Media",
                "description": "Sell your products and affiliate products",
                "icon": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": "social"
            },
            {
                "title": "Live Events",
                "description": "Market your business",
                "icon": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": "events"
            },
            {
                "title": "Support",
                "description": "Contact us",
                "icon": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": "support"
            },
            {
                "title": "More Sites",
                "description": "More From Groove",
                "icon": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": "more"
            }
        ],
        "apps": [
            {
                "title": "Dashboard",
                "description": "Your Groove Home",
                "slug": "dashboard",
                "url": "/#/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "apps"
                ],
                "target": "_self"
            },
            {
                "title": "GroovePages",
                "description": "Intuitive & easy to use page + funnel builder",
                "slug": "pages",
                "url": "/groovepages/",
                "logo": "https://assets.grooveapps.com/css/groovepages.svg",
                "type": [
                    "apps"
                ],
                "target": "_self"
            },
            {
                "title": "GrooveSell",
                "description": "Sell Digital Products and Affiliate Management",
                "slug": "sell",
                "url": "/groovesell/",
                "logo": "https://assets.grooveapps.com/css/groovesell.svg",
                "type": [
                    "apps"
                ],
                "target": "_self"
            },
            {
                "title": "GrooveAffiliate",
                "description": "Promote products and earn commissions",
                "slug": "affiliate",
                "url": "/groovesell/affiliates-dashboard",
                "logo": "https://assets.grooveapps.com/css/grooveaffiliates.svg",
                "type": [
                    "apps"
                ],
                "target": "_self"
            },
            {
                "title": "GrooveMail",
                "description": "Simple yet powerful email marketing automation",
                "slug": "mail",
                "url": "/groovemail/",
                "logo": "https://assets.grooveapps.com/css/groovemail.svg",
                "type": [
                    "apps"
                ],
                "target": "_self"
            },
            {
                "title": "GrooveMember",
                "description": "Create membership sites in minutes",
                "slug": "member",
                "url": "/groovemember/",
                "logo": "https://assets.grooveapps.com/css/grooveamember.svg",
                "type": [
                    "apps"
                ],
                "target": "_self"
            },
            {
                "title": "GrooveVideo",
                "description": "Advanced, marketing-oriented video player",
                "slug": "video",
                "url": "/groovevideo/",
                "logo": "https://assets.grooveapps.com/css/groovevideo.svg",
                "type": [
                    "apps"
                ],
                "target": "_self"
            },
            {
                "title": "GrooveBlog",
                "description": "Blog creation made easy",
                "slug": "blog",
                "url": "/grooveblog/",
                "logo": "https://assets.grooveapps.com/css/grooveblog.svg",
                "type": [
                    "apps"
                ],
                "target": "_self"
            },
            {
                "title": "GrooveKart",
                "description": "Next level e-commerce, drop-shipping and more",
                "slug": "kart",
                "url": "/static/groovekart",
                "logo": "https://assets.grooveapps.com/css/groovekart.svg",
                "type": [
                    "apps"
                ],
                "target": "_self"
            },
            {
                "title": "GrooveWebinar",
                "description": "Create Powerful Marketing Webinars",
                "slug": "webinar",
                "url": "/groovewebinar/",
                "logo": "https://assets.grooveapps.com/css/groovewebinar.svg",
                "type": [
                    "apps"
                ],
                "target": "_self"
            },
            {
                "title": "Mobile App",
                "description": "Download the Mobile App for real times sales data",
                "slug": "mobile",
                "url": "https://groove.how/apps/groove-cm-mobile-app/",
                "logo": "https://assets.grooveapps.com/css/groovemobile.svg",
                "type": [
                    "apps"
                ],
                "target": "_blank"
            },
            {
                "title": "GrooveDesignerPro",
                "description": "Create Amazing Graphics & Designs In Minutes Without Any Design Skills!",
                "slug": "designer",
                "url": "https://groovedesignerpro.com/",
                "logo": "https://assets.grooveapps.com/css/groovedesignerpro.svg",
                "type": [
                    "apps"
                ],
                "target": "_blank"
            },
            {
                "title": "GrooveDigital Academy",
                "description": "Learn Groove From The Team That Built Groove",
                "slug": "academy",
                "url": "https://groovedigitalacademy.com/training",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "training"
                ],
                "target": "_blank"
            },
            {
                "title": "Tutorials",
                "description": "Access Groove.how",
                "slug": "tutorials",
                "url": "https://groove.how",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "training"
                ],
                "target": "_blank"
            },
            {
                "title": "Support",
                "description": "Groove Support",
                "slug": "support",
                "url": "https://groovesupport.net",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "support"
                ],
                "target": "_blank"
            },
            {
                "title": "GroovePay",
                "description": "Better Merchant Processing.",
                "slug": "pay",
                "url": "https://www.groovepay.com/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "services"
                ],
                "target": "_blank"
            },
            {
                "title": "GrooveAds",
                "description": "Full Service Advertising Agency From Groove",
                "slug": "adds",
                "url": "https://grooveads.com/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "services"
                ],
                "target": "_blank"
            },
            {
                "title": "GrooveSolos",
                "description": "INSTANT quality traffic!",
                "slug": "solos",
                "url": "https://groovesolos.com/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "services"
                ],
                "target": "_blank"
            },
            {
                "title": "GrooveKon",
                "description": "The Ultimate Digital Marketing and eCommerce Event",
                "slug": "",
                "url": "https://groovekon.com/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "events"
                ],
                "target": "_blank"
            },
            {
                "title": "The Marketers Cruise",
                "description": "Mastermind in Paradise",
                "slug": "",
                "url": "https://marketerscruise.com/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "events"
                ],
                "target": "_blank"
            },
            {
                "title": "Blog",
                "description": "Latest news from GrooveDigital",
                "slug": "",
                "url": "https://groovefunnels.com/blog/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "more"
                ],
                "target": "_blank"
            },
            {
                "title": "GrooveDigital",
                "description": "Corporate Site",
                "slug": "digital",
                "url": "https://groovedigital.com/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "more"
                ],
                "target": "_blank"
            },
            {
                "title": "GrooveGear",
                "description": "Get Your Groove Gear Today",
                "slug": "",
                "url": "https://groovegear.com/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "more"
                ],
                "target": "_blank"
            },
            {
                "title": "GrooveJV",
                "description": "Groove Partner Program",
                "slug": "",
                "url": "https://groovejv.com/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "more"
                ],
                "target": "_blank"
            },
            {
                "title": "Facebook Group",
                "description": "Official group for the GrooveDigital, Inc. brand",
                "slug": "",
                "url": "http://groovedigitalfb.com/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "social"
                ],
                "target": "_blank"
            },
            {
                "title": "Facebook Page",
                "description": "Official facebook page for the GrooveDigital, Inc. brand",
                "slug": "",
                "url": "https://www.facebook.com/groovefunnels/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "social"
                ],
                "target": "_blank"
            },
            {
                "title": "Twitter",
                "description": "Official twitter handle for the GrooveDigital, Inc. brand",
                "slug": "",
                "url": "https://twitter.com/cm_groove",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "social"
                ],
                "target": "_blank"
            },
            {
                "title": "Youtube",
                "description": "Official youtube channel for the GrooveDigital, Inc. brand",
                "slug": "",
                "url": "https://www.youtube.com/channel/UCDjO_whAitBMCFUb6EJZO_g",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "social"
                ],
                "target": "_blank"
            },
            {
                "title": "LinkedIn",
                "description": "Official linkedin account of the GrooveDigital, Inc. brand",
                "slug": "",
                "url": "https://www.linkedin.com/company/groovedigital-software/mycompany/",
                "logo": "https://assets.grooveapps.com/css/groovecm.svg",
                "type": [
                    "social"
                ],
                "target": "_blank"
            }
        ]
      };
      
      commit('setBrandData', branding);
      // temporary brand styles
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = 'https://assets.grooveapps.com/css/main.css';
      document.head.appendChild(stylesheet);
      // will be replaced by groove api
    }
  },
  getters: {
    brandData: state => state.brandData,
  }
};
